import { render, staticRenderFns } from "./_OrganizationLogo.vue?vue&type=template&id=152d22ad&scoped=true&"
import script from "./_OrganizationLogo.vue?vue&type=script&lang=js&"
export * from "./_OrganizationLogo.vue?vue&type=script&lang=js&"
import style0 from "./_OrganizationLogo.vue?vue&type=style&index=0&id=152d22ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152d22ad",
  null
  
)

export default component.exports